import { Link } from "expo-router";
import { Pressable, Text, View } from "react-native";

export default function ConfirmScreen() {
  return (
    <View className="flex-1 items-center justify-center bg-bg px-6">
      <View className="w-full max-w-md rounded-lg border border-border bg-white p-8">
        <Text className="text-center text-lg font-semibold text-primary">Check your email</Text>
        <Text className="mt-3 text-center text-sm leading-relaxed text-primary/80">
          We sent a confirmation link. Open it to finish setting up your account, then sign in.
        </Text>
        <Link href="/login" asChild>
          <Pressable className="mt-8 items-center rounded-md bg-primary py-3">
            <Text className="font-semibold text-white">Back to Login</Text>
          </Pressable>
        </Link>
      </View>
    </View>
  );
}
